import Script from 'next/script'

export default function NetID() {
  return (
    <Script
      id="netId"
      src="https://te-static.technical-service.net/netid/ntvde.min.js"
      onLoad={() => console.log('[NetID] NetID script loaded')}
      onError={(error) => console.error('[NetID] Error while loading NetID script ', error)}
      strategy="afterInteractive"
    />
  )
}
